import React from 'react';

const UpDateBike = () => {
  return (
    <div>
      <h1>helllo</h1>
    </div>
  );
};

export default UpDateBike;